var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-stat-item flex justify-between py-4 border-0 border-t border-solid border-gray-300"},[_c('span',{staticClass:"ds-text-sm uppercase font-bold text-gray-800 whitespace-no-wrap"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"ds-text-sm text-gray-700 whitespace-no-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }